import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { FlowFlowModel, OwnerPropertiesSummary, WealthInfo } from './models';

export function fetchHomeownerPropertiesService(client: ApiClient = apiClient) {
  return client.get<OwnerPropertiesSummary>('/homeowners/properties');
}

export function fetchHomeownerFlowsService(client: ApiClient = apiClient) {
  return client.get<FlowFlowModel[]>('/homeowners/flows');
}

export function fetchHomeownerWealthService(client: ApiClient = apiClient) {
  return client.get<WealthInfo[]>('/homeowners/wealth');
}
